// ACTIONS
function setCategoryCacheAction({ commit }, payload) {
  commit('setCategoryCache', payload)
}

// INITIAL STATE DECLARATION

const initialState = () => ({
  cachedCategory: null
})

// MUTATIONS
function setCategoryCache(state, category) {
  state.cachedCategory = category
}

const categoryCacheStore = {
  state: initialState(),
  actions: {
    setCategoryCacheAction
  },
  getters: {
    cachedCategory: state => state.cachedCategory
  },
  mutations: {
    setCategoryCache
  }
}

export default categoryCacheStore
